const STORAGE_KEY = "logboek24.navigationLayout";
const DEFAULT_LAYOUT = "topMegaMenu";
const VALID_LAYOUTS = new Set([
  "topMegaMenu",
  "existing",
  "sideMenu",
  "compactIconMenu",
]);

export const NAVIGATION_LAYOUT_OPTIONS = Object.freeze([
  {
    value: "topMegaMenu",
    label: "Top megamenu",
    description: "Nieuwe hoofdgroepen met klikbare dropdownpanelen.",
  },
  {
    value: "existing",
    label: "Bestaande weergave",
    description: "Klassieke hoofdmenu- en submenu-opbouw.",
  },
  {
    value: "sideMenu",
    label: "Zijmenu",
    description: "Volledige groepsnavigatie links naast de inhoud.",
  },
  {
    value: "compactIconMenu",
    label: "Compact iconmenu",
    description: "Smalle iconenrail met groepspaneel voor compacte cockpitnavigatie.",
  },
]);

export const NAVIGATION_LAYOUT_CHANGE_EVENT = "logboek24:navigation-layout-change";

export function normalizeNavigationLayout(value) {
  const key = String(value || "").trim();
  return VALID_LAYOUTS.has(key) ? key : DEFAULT_LAYOUT;
}

export function getStoredNavigationLayout() {
  if (typeof window === "undefined") return DEFAULT_LAYOUT;
  try {
    return normalizeNavigationLayout(window.localStorage.getItem(STORAGE_KEY));
  } catch {
    return DEFAULT_LAYOUT;
  }
}

export function saveNavigationLayout(value) {
  const next = normalizeNavigationLayout(value);

  if (typeof window !== "undefined") {
    try {
      window.localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // Ignore localStorage write failures for UI preference.
    }

    try {
      window.dispatchEvent(
        new CustomEvent(NAVIGATION_LAYOUT_CHANGE_EVENT, {
          detail: { value: next },
        })
      );
    } catch {
      // Ignore event dispatch failures.
    }
  }

  return next;
}
